__webpack_require__.p = "/powerbi/";